import ReactLoading from 'react-loading';
import { IRecipient } from '@nkr/models/recipient';
import useEpletGraphData from '@nkr/store/recipient/hooks/use-eplet-graph-data';
import EpletMmGraph from '@nkr/views/matching/results-new/eplet-mm-graph/eplet-mm-graph';
import { styles } from './styles';

interface IProps {
    recipient: IRecipient
}

const ToolboxEpletGraph = (props: IProps) => {
    const { data, loading } = useEpletGraphData(props.recipient.id);

    if (loading) {
        return (
            <div style={styles.chartWrapper}>
                <div style={styles.chartLoading}>
                    <ReactLoading type={'spin'} color={'black'} />
                </div>
            </div>
        );
    }

    if (data == null || !data.hasMismatchCount) {
        return null;
    }

    return (
        <div style={styles.chartWrapper}>
            <EpletMmGraph graphData={data} recipient={props.recipient} />
        </div>
    );
};

export default ToolboxEpletGraph;
